<p-fileUpload name="demo[]" [url]="uploadConfigs.uploadAPI.url" [multiple]="uploadConfigs.isMultiple" [auto]="false"
    [cancelLabel]="'Reset'" [uploadLabel]="'Upload'" [showUploadButton]="true" [showCancelButton]="true"
    [maxFileSize]="uploadConfigs.maxUploadSize"
    accept="{{uploadConfigs.formatsAllowed ? uploadConfigs.formatsAllowed : '.png, .jpg, .jpeg, .xls'}}"
    (onSelect)="onSelectFileUpload($event)" (onUpload)="onUpload($event)" [customUpload]="isCustomUpload"
    (uploadHandler)="onUploadHandler($event)">
    <ng-template pTemplate="content">
        <ul>
            <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
        </ul>
    </ng-template>
</p-fileUpload>

<!-- <angular-file-uploader
      [config]="configs">
</angular-file-uploader> -->

<div class="col-md-12 footer">
    <button class="btn btn-primary align-right" (click)="onFinishedUpload()">Done</button>
</div>